"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opcionesCompraDefecto = void 0;
exports.opcionesCompraDefecto = {
    comprobanteContado: true,
    comprobanteCredito: true,
    comprobanteDefecto: "contado",
    tasaIVADefecto: "",
    vistaPrecioDefecto: "sinIVA",
    monedaDefecto: "",
    cantidadDecimales: 2,
    controlarCaja: false
};
